import * as React from 'react';
import { TopNavView, TopNavViewProps } from './TopNav.view';
import { SelectItem } from '../../components/forms/Select/Select.view';
import { useForm, UseFormReturn } from 'react-hook-form';
import { FormOptions } from '../../constants/form';
import { useUserData } from '../../hooks/useUserData';
import { GetMeQuery } from '../../models/graphql';
import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTopNavVisibility } from '../../hooks/useTopNavVisibility';
import { AppContext, changeSelectedWorkspaceId } from '../../providers/AppProvider';
import { FormElementValueType } from '../../models/basic-objects';

export const getWorkspaceOrganizations = (
  selectedWorkspaceId: string,
  userData: GetMeQuery['me']
): (SelectItem | string)[] => {
  let organizations: (SelectItem | string)[] = [];
  userData?.organizations.forEach(organization => {
    const workspaces: SelectItem[] =
      organization.workspaces.map<SelectItem>(
        workspace =>
          ({
            label: workspace.name,
            value: workspace.id
          } as SelectItem)
      ) || [];
    organizations = [...organizations, organization.name].concat(workspaces);
  });
  return organizations;
};

export type TopNavControllerProps = Omit<
  TopNavViewProps,
  'workspaceSwitcher' | 'hamburgerMenu' | 'selectedWorkspaceId'
> & {
  // add controller props
};

export type HamburgerMenuType = {
  openHamburgerMenu: boolean;
  setOpenHamburgerMenu: Dispatch<SetStateAction<boolean>>;
};

export type WorkspaceSwitcher = {
  changeWorkspaceAction: (value: FormElementValueType) => void;
  organizations: (SelectItem | string)[];
  useFormInstance: UseFormReturn;
};

export const TopNavController = (props: TopNavControllerProps): JSX.Element => {
  const { selectedWorkspaceId, showLoadingOverlay } = useContext(AppContext);
  useTopNavVisibility('top');
  const { userData } = useUserData();
  const organizations = getWorkspaceOrganizations(selectedWorkspaceId, userData);
  const [openHamburgerMenu, setOpenHamburgerMenu] = useState<boolean>(false);

  const useFormInstance = useForm({
    ...FormOptions,
    mode: 'onSubmit'
  });

  const changeWorkspaceAction = (value: FormElementValueType) => {
    showLoadingOverlay(true);
    changeSelectedWorkspaceId(`${value}`);
  };

  const workspaceSwitcher: WorkspaceSwitcher = {
    changeWorkspaceAction,
    organizations,
    useFormInstance
  };

  const hamburgerMenu: HamburgerMenuType = {
    openHamburgerMenu,
    setOpenHamburgerMenu
  };

  const viewProps: TopNavViewProps = {
    ...props,
    hamburgerMenu,
    selectedWorkspaceId,
    workspaceSwitcher
  };

  return <TopNavView {...viewProps} />;
};
